export const ADMIN_EMAILS = ['stomatrix@gmail.com', 'saurav@xagi.in'] as const;

export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.trim().toLowerCase() as (typeof ADMIN_EMAILS)[number]);
}
